module.exports = __webpack_public_path__ + "static/ngoto95660708-e02f75dcdaf34c9e3f6edb702c874330.jpg";